
<template>
<div class="modal-background">
  <div class="modal">
    <img src="@/assets/select.png">
    <p>Press anywhere to start</p>
    <a href="https://www.flaticon.com/free-icons/hand" title="hand icons">Hand icons from Flaticon</a>
  </div>
</div>
</template>

<style lang="scss">
.modal-background {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;

  background-color: hsla(0,0%,53%,.533);
  backdrop-filter: blur(2px);

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  .modal {
    padding: 2em;
    border-radius: 1em;

    background-color: #fff;
    font-size: 1em;
    text-align: center;

    img {
      width: 5em;
      margin-bottom: 0.5em;
    }

    p {
      font-weight: 700;
    }

    a {
      font-style: italic;
      color: #ccc;
    }
  }
}
</style>
